import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {
    Step,
    StepRecordFormProps
} from '../types';
import {stage} from "../../../config/stage";

export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: StepRecordFormProps) => {

    const onSubmit = (values: Step) => {
        handleSubmit(values);
    };


    let initialValues = {
        position: 0,
    } as Step;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            enableReinitialize
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
